import { CobaltBanner } from '@cae/cobalt-react/components/banner';
import React from 'react';

import type { ErrorBannerProps } from './ErrorBanner.types';

import styles from './ErrorBanner.module.css';

const ErrorBanner = React.memo(
  ({ message, onDismiss }: Readonly<ErrorBannerProps>): React.ReactElement => {
    return (
      <CobaltBanner
        variant="danger"
        className={styles.errorBanner}
        hasClose={!!onDismiss}
        showIcon
        onClose={onDismiss}
        data-testid="error-banner"
      >
        {message}
      </CobaltBanner>
    );
  }
);

ErrorBanner.displayName = 'ErrorBanner';

export { ErrorBanner };
